import React, { useEffect, useState, useRef } from "react";
import { API } from "../../helper/Api";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select"; // Import React Select
import makeAnimated from "react-select/animated";

const ShopifyExtract = () => {
  // State to track selected permissions and role/category
  const API_URL = process.env.REACT_APP_BASE_URL;
  const SHOPIFY_URL = process.env.REACT_APP_SHOPIFY_URL;
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [getStoreNumber, setGetStoreNumber] = useState([]);
  const [storeNumber, setStoreNumber] = useState([]);
  const [zipFile, setZipFile] = useState(false);
  const [type, setType] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [validation, setvalidation] = useState({
    storeNumber: "",
    type: "",
    fromDate: "",
    toDate: "",
  });
  let track = false;
  const SELECT_ALL_OPTION = { value: "*", label: "Select All" };
  const TYPE_SELECT_ALL_OPTION = { value: "*", label: "Select All" };
const typeOptions = [
  TYPE_SELECT_ALL_OPTION,
  { value: "header", label: "Sales Header" },
  { value: "line", label: "Sales Line Item" },
  { value: "item", label: "Item" },
  { value: "inventory", label: "Inventory" },
];

  const fetchStores = async () => {
    try {
      const res = await API.accessSetting("getStoreDetails", "");
      if (res.status === "success") {
        // Assuming API returns a list of users, prepare options for the dropdown
        setGetStoreNumber(res.storeDetails || []);

        //console.log("stores are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching stores");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Call fetchData initially when the component mounts
  useEffect(() => {
    fetchStores();
  }, []);

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    try {
       console.log("check store no->",storeNumber);
      if (storeNumber.length === 0 || storeNumber === null) {
        track = true;
        setvalidation((prev) => ({
          ...prev,
          storeNumber: "Store number is required",
        }));
      }
      if (type.length === 0 || type === null) {
        track = true;
        setvalidation((prev) => ({
          ...prev,
          type: "Type is required",
        }));
      }
      if (fromDate === "" || fromDate === null) {
        track = true;
        setvalidation((prev) => ({
          ...prev,
          fromDate: "From date is required",
        }));
      }
      if (toDate === "" || toDate === null) {
        track = true;
        setvalidation((prev) => ({
          ...prev,
          toDate: "To date is required",
        }));
      }
      // Reset validation state
      if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
        track = true;
        setvalidation((prev) => ({
          ...prev,
          toDate: "From date cannot be greater than To date",
        }));
      }
      if (!track) {
        const apiData = {
          store_no: storeNumber,
          type: type,
          from_date: fromDate,
          to_date: toDate,
        };
        //console.log("success")

        const res = await API.accessSetting("submitExtractData", apiData);
        console.log("API Response:", res);
        if (res.status === "success") {
          if (zipFile) {
            const zipFilePath = `${SHOPIFY_URL}extracts/salesextract/${res.zipFilePath}`; // Get the zip file path from the response
            const link = document.createElement("a");
            link.href = zipFilePath;
            link.download = res.zipFilePath; // Set the default file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          // Reset form fields
          setStoreNumber([]);
          setType([]);
          setFromDate("");
          setToDate("");
          setZipFile(false);
          toast.success(res.message, {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            className: "login-toast",
          });
        } else {
          // Handle error response
          setStoreNumber([]);
          setType([]);
          setFromDate("");
          setToDate("");
          setZipFile(false);
          toast.error("Failed to extract data. Please try again.", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            className: "login-toast",
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error); // Handle errors
    }
  };

  const containerStyles = {
    padding: "30px",
    width: "60%",
    borderRadius: "8px",
    // backgroundColor: '#f8f9fa',
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Light shadow for a floating effect
  };

  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    marginBottom: "15px",
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };

  return (
    <div className="container-fluid page-body-wrapper">
      {/* Add the Shake Keyframe Animation */}

      <div className="main-panel">
        <div className="content-wrapper">
          <ToastContainer
            position="top-center"
            autoClose={500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="container mainbody">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 className="form-header">Extract Data</h2>
            </div>

            <form onSubmit={handleFormSubmit} style={{ marginTop: "15px" }}>
              {/* Role label in a separate row */}
              <div className="form-group">
                <label htmlFor="storeNumber" style={labelStyles}>
                  Enter Store Number:<span className="requireds">*</span>
                  {validation.storeNumber != "" && (
                    <span className="fieldValidation">
                      {validation.storeNumber}
                    </span>
                  )}{" "}
                </label>
                <Select
                  id="storeNumber"
                  value={storeNumber}
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  isMulti
                  onChange={(selectedOption) => {
                    if (!selectedOption) {
                      setStoreNumber([]);
                      return;
                    }
                    // If "Select All" is selected
                    if (selectedOption.some((opt) => opt.value === "*")) {
                      // If not all are selected, select all
                      if (storeNumber.length !== getStoreNumber.length) {
                        setStoreNumber(getStoreNumber);
                      } else {
                        // If all are selected and "Select All" is clicked, clear all
                        setStoreNumber([]);
                      }
                    } else {
                      setStoreNumber(selectedOption);
                    }
                    setvalidation((prev) => ({ ...prev, storeNumber: "" }));
                  }}
                  options={[SELECT_ALL_OPTION, ...getStoreNumber]}
                  placeholder="Select Store Number"
                  className="newselect1"
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#1967d2",
                      primary: "rgb(3 207 217)",
                    },
                  })}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      minHeight: "47px",
                    }),
                    placeholder: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "#6c757d",
                      outline: "none",
                      fontSize: "14px",
                    }),
                    input: (baseStyles, state) => ({
                      ...baseStyles,
                      outline: "none",
                    }),
                    option: (base, state) => ({
                      ...base,
                      color: state.isFocused ? "#fff" : "#000",
                      backgroundColor: state.isFocused ? "#1967d2" : "#fff",
                    }),
                  }}
                />

                <label htmlFor="type" style={labelStyles}>
                  Select Type<span className="requireds">*</span>
                  {validation.type != "" && (
                    <span className="fieldValidation">{validation.type}</span>
                  )}
                </label>
                <Select
  value={type}
  closeMenuOnSelect={false}
  components={animatedComponents}
  isMulti
  onChange={(selectedOption) => {
    if (!selectedOption) {
      setType([]);
      return;
    }
    // If "Select All" is selected
    if (selectedOption.some(opt => opt.value === "*")) {
      // If not all are selected, select all
      if (type.length !== typeOptions.length - 1) {
        setType(typeOptions.slice(1)); // Exclude "Select All" itself
      } else {
        // If all are selected and "Select All" is clicked, clear all
        setType([]);
      }
    } else {
      setType(selectedOption);
    }
    setvalidation((prev) => ({ ...prev, type: "" }));
  }}
  options={typeOptions}
  placeholder="Select type"
  className="newselect1"
  theme={(theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "#1967d2",
      primary: "rgb(3 207 217)",
    },
  })}
  styles={{
    control: (baseStyles, state) => ({
      ...baseStyles,
      minHeight: "47px",
    }),
    placeholder: (baseStyles, state) => ({
      ...baseStyles,
      color: "#6c757d",
      outline: "none",
      fontSize: "14px",
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      outline: "none",
    }),
    option: (base, state) => ({
      ...base,
      color: state.isFocused ? "#fff" : "#000",
      backgroundColor: state.isFocused ? "#1967d2" : "#fff",
    }),
  }}
/>
                {/* <select
                  id="type"
                  className="form-control"
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                    setvalidation((prev) => ({ ...prev, type: "" }));
                  }}
                  style={{ ...selectStyles, marginRight: "10px" }}
                >
                  <option value="">Select type</option>
                  <option value="header">Sales Header</option>
                  <option value="line">Sales Line Item</option>
                </select> */}
                <label htmlFor="fromDate" style={labelStyles}>
                  From Date<span className="requireds">*</span>
                  {validation.fromDate != "" && (
                    <span className="fieldValidation">
                      {validation.fromDate}
                    </span>
                  )}
                </label>
                <input
                  id="fromDate"
                  type="date"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    setvalidation((prev) => ({ ...prev, fromDate: "" }));
                    setvalidation((prev) => ({ ...prev, toDate: "" }));
                  }}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height: "47px",
                    color: "black",
                  }}
                />
                <label htmlFor="toDate" style={labelStyles}>
                  To Date<span className="requireds">*</span>
                  {validation.toDate != "" && (
                    <span className="fieldValidation">{validation.toDate}</span>
                  )}
                </label>
                <input
                  id="toDate"
                  type="date"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    setvalidation((prev) => ({ ...prev, toDate: "" }));
                  }}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height: "47px",
                    color: "black",
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "-50px",
                  }}
                >
                  <input
                    type="checkbox"
                    id="zipFile"
                    checked={zipFile}
                    onChange={(e) => setZipFile(e.target.checked)}
                    style={{ width: "16px" }}
                  />
                  <label style={{ marginTop: "4px", marginLeft: "4px" }}>
                    Create Zip File
                  </label>
                </div>
              </div>
              {/* Submit button */}
              <div style={{ display: "flex", gap: "5px" }}>
                <button
                  type="submit"
                  className="submit-btn"
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopifyExtract;
